export default {
  loginInfo:{
    uuid:undefined,
    access_token:undefined,
    refresh_token:undefined,
    expires_in:undefined
  },
  user:{

  },
  pageLoad:{
    path:""
  }
}



// WEBPACK FOOTER //
// ./src/store/axj-web/state.js